import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { useNotificationContext } from '../../contexts/NotificationContext';

export function NotificationBell() {
  const { unreadCount } = useNotificationContext();
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="icon-btn notification-bell"
      onClick={() => navigate('/notifications')}
      title="Notifications"
      aria-label={unreadCount > 0 ? `${unreadCount} unread notifications` : 'Notifications'}
    >
      <Bell size={18} strokeWidth={2} />
      {unreadCount > 0 && (
        <span className="notification-bell-badge" aria-hidden>
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}
